<template>
  <generic-container
    :title="$t('prototypes')"
    icon="list"
    ref="container"
    :searchable="true"
    :show_toggle="true"
    @filter="filterItems"
  >
    <div class="ui six link cards">
      <div
        class="card"
        v-for="mdle in shown_prototypes"
        v-bind:key="mdle.uuid"
        v-on:click="select(mdle)"
        style="margin: 10px 10px !important"
      >
        <div class="content">
          <h3 class="ui icon header" style="margin-bottom:0">
            <img src="/images/icons/generic_prototype.jpeg" class="ui image" />
            <div class="content" style="margin-top:8px">
              {{ mdle.name }}
            </div>
          </h3>
        </div>
      </div>
    </div>
    <!-- <pre>{{ shown_prototypes }}</pre> -->
    <!-- <div class="ui dividing header">{{ $t("reports") }}</div> -->
    <!-- <div class="ui list">
      <div
        class="item"
        v-for="(rpt, idx) in this.shown_prototypes"
        :key="idx"
        @click="select(rpt)"
      >
        <i class="text file icon"></i>
        <div class="content">
          <div class="header">{{ rpt.name }}</div>
          <div class="description">{{ rpt.description }}</div>
        </div>
      </div>
    </div> -->
  </generic-container>
</template>

<script>
import { local_api, clone } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "PrototypeList",
  components: { GenericContainer },
  filters: filters,
  data() {
    return {
      // reports_by_prototype: [],
      shown_prototypes: [],
      all_prototypes: [],
      loading: false,
    };
  },
  computed: {},
  methods: {
    select(itm) {
      this.$emit("selected", itm);
      // this.$refs.container.toggle();
    },
    filterItems(value) {
      let filtered = this.all_prototypes.filter((r) => {
        let existsInPrototypeName = r.name.includes(value);
        let existsInPrototypeDescription = r.description.includes(value);
        return existsInPrototypeName || existsInPrototypeDescription;
      });
      console.log(filtered);
      this.shown_prototypes = filtered;
    },
  },
  created() {
    let vm = this;
    vm.loading = true;
    local_api(vm, "post", "/prototype/composer/do-get-all")
      .then((rpts) => {
        vm.loading = false;
        vm.shown_prototypes = rpts;
        vm.all_prototypes = clone(rpts);
        // let _r = reports_by_prototype.map((m) => {
        //   m.show_reports = true;
        //   return m;
        // });
        // this.reports_by_prototype = _r;
      })
      .catch((err) => {
        vm.loading = false;
        vm.$alertify.error(JSON.stringify(err, null, 2));
      });
  },
  mounted() {},
  watch: {
    loading() {
      this.$refs.container.set_loading(this.loading);
    },
  },
};
</script>
